import React from 'react'
import 'css/markdown-styles.css'
import Helmet from 'react-helmet'
import { config } from 'config'

const twitter = <div id="footer">
    <a type="application/rss+xml" href="http://philipnilsson.github.io/Badness10k/atom.xml">
        RSS feed for this page
    </a>
    <a href="https://twitter.com/ali_pang"
       className="twitter-follow-button"
       data-show-count="false"
       data-size="large"
    >
        Follow @ali_pang
    </a>
</div>;

function formatDate(date) {
    var monthNames = [
        "January", "February", "March",
        "April", "May", "June", "July",
        "August", "September", "October",
        "November", "December"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();

    return `${monthNames[monthIndex]} ${day}, ${year}`;
}

module.exports = React.createClass({
    componentDidMount() {
        this.mount(this.props);
    },

    componentDidUpdate(props) {
        this.mount(props);
    },

    mount(props) {
        if (window.MathJax) {
            window.MathJax.Hub.Typeset();
        }
        const url = props.location.pathname === '/escaping-hell-with-monads/'
              ? '/posts/2017-05-07-escaping-hell-with-monads.html'
              : props.location.pathname;

        window.disqus_config = function () {
            this.page.url = `https://philipnilsson.github.io/Badness10k${props.location.pathname}`;
            this.page.identifier = document.title;
        };
        if (window.DISQUS) {
            window.DISQUS.reset({ reload: true, config: window.disqus_config });
        } else {
            var d = document, s = d.createElement('script');
            s.src = 'https://badness-10-000.disqus.com/embed.js';
            s.setAttribute('data-timestamp', +new Date());
            (d.head || d.body).appendChild(s);
        }
    },

    propTypes () {
        return {
            router: React.PropTypes.object,
        }
    },
    render () {
        const post = this.props.route.page.data
        const date = formatDate(new Date(this.props.route.page.data.date));

        return (
                <div className="markdown">
                <Helmet
            title={`${config.siteTitle} | ${post.title}`}
                />
                { this.props.route.page.path === "/404.html" ? null :
                  <div className="header">
                  <h1>{post.title}</h1>
                  <span>Posted on {date}</span>
                  </div>
                }

                <div dangerouslySetInnerHTML={{ __html: post.body }} />
                {twitter}
                <div id="disqus_thread"/>
              </div>
        )
    },
});



// WEBPACK FOOTER //
// ../wrappers/md.js